import { combineReducers } from "redux";
import AccountReducer from "./Account/reducer";
import AppointmentReducer from "./appointment/reducer";
import ApprovalsReducers from "./Approvals/reducer";
import AuthReducer from "./Auth/reducer";
import CalendarReducer from "./Calendar/reducer";
import CustomerReducer from "./Customer/reducer";
import DasboardReducer from "./Dashboard/reducer";
import EstimateReducer from "./Estimate/reducer";
import InvoiceReducer from "./Invoice/reducer";
import NotificationReducers from "./Notification/reducer";
import PauseAppointmentReducer from "./PauseAppointment/reducer";
import SettingReducer from "./Settings/reducer";
import VehicleReducer from "./Vehicles/reducer";
import SupplierReducer from "./Supplier/reducer";
import InventoryReducer from "./Inventory/reducer";
import SavedServiceReducer from "./SavedServices/reducer";

const rootReducers = combineReducers({
  auth: AuthReducer,
  account: AccountReducer,
  Notification: NotificationReducers,
  dashboard: DasboardReducer,
  estimate: EstimateReducer,
  customer: CustomerReducer,
  vehicle: VehicleReducer,
  customer: CustomerReducer,
  supplier: SupplierReducer,
  inventory: InventoryReducer,
  invoice: InvoiceReducer,
  approvals: ApprovalsReducers,
  appointment: AppointmentReducer,
  calendar: CalendarReducer,
  pauseAppointment: PauseAppointmentReducer,
  savedService: SavedServiceReducer,
  setting: SettingReducer,
});
export default rootReducers;
